import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, mergeProps as _mergeProps, unref as _unref, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = { class: "group-header-default" };
const _hoisted_2 = {
    key: 1,
    class: "flex justify-center"
};
const _hoisted_3 = { key: 2 };
const _hoisted_4 = { class: "group-footer-default" };
import TableDropdownMenu from "@/components/uikit/platformComponents/TableDropdownMenu.vue";
import UPaginator from "@/components/uikit/uComponents/UPaginator.vue";
import { computed } from "vue";
import { DataTable, Column as TableColumn } from "primevue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'UTable',
    props: {
        items: {
            type: Array,
            required: true,
            default: () => []
        },
        totalItems: {
            type: Number,
            default: 0
        },
        columns: {
            type: Array,
            required: true
        },
        groupBy: {
            type: String,
            default: ""
        },
        loading: {
            type: Boolean,
            default: false
        },
        options: {
            type: Object,
            default: () => ({
                rowGroupMode: "subheader",
                sortMode: "single",
                sortOrder: 1,
                scrollable: true
            })
        }
    },
    emits: ["page"],
    setup(__props, { expose: __expose, emit: __emit }) {
        const props = __props;
        const totalRecords = computed(() => {
            return props.items?.length;
        });
        const isPaginationVisibility = computed(() => {
            return props.totalItems > 30;
        });
        // Определяем событие для отправки наружу
        const emit = __emit;
        const onPageChange = (event) => {
            emit("page", event);
        };
        // Функция для вычисления количества элементов в группе
        const calculateGroupCount = (groupValue) => {
            return props.items.filter((item) => item[props.groupBy] === groupValue)
                .length;
        };
        __expose({
            calculateGroupCount
        });
        function getColumnStyle(column) {
            let columnHeaderAlign = "";
            switch (column.align) {
                case "center":
                    columnHeaderAlign = "center";
                    break;
                case "right":
                    columnHeaderAlign = "flex-end";
                    break;
                default:
                    break;
            }
            return {
                "text-align": column.align,
                "--column-header-align": columnHeaderAlign
            };
        }
        return (_ctx, _cache) => {
            const _component_UProgressBar = _resolveComponent("UProgressBar");
            const _component_UText = _resolveComponent("UText");
            const _component_UDecimal = _resolveComponent("UDecimal");
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(_unref(DataTable), _mergeProps({
                    value: __props.loading ? [] : __props.items
                }, __props.options, {
                    "group-rows-by": __props.groupBy,
                    "row-group-mode": __props.groupBy ? 'subheader' : '',
                    "sort-field": __props.groupBy
                }), {
                    groupheader: _withCtx((slotProps) => [
                        _renderSlot(_ctx.$slots, "groupHeader", {
                            item: slotProps.data,
                            groupValue: slotProps.data[__props.groupBy],
                            index: slotProps.index
                        }, () => [
                            _createElementVNode("div", _hoisted_1, " Group: " + _toDisplayString(slotProps.data[__props.groupBy]), 1)
                        ])
                    ]),
                    empty: _withCtx(() => [
                        (__props.loading)
                            ? (_openBlock(), _createBlock(_component_UProgressBar, {
                                key: 0,
                                green: "",
                                "is-loader": ""
                            }))
                            : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                _createVNode(_component_UText, { severity: "secondary" }, {
                                    default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                                            _createTextVNode(" No data ", -1)
                                        ]))]),
                                    _: 1
                                })
                            ]))
                    ]),
                    groupfooter: _withCtx((slotProps) => [
                        _renderSlot(_ctx.$slots, "groupFooter", {
                            item: slotProps.data,
                            groupValue: slotProps.data[__props.groupBy],
                            count: calculateGroupCount(slotProps.data[__props.groupBy]),
                            index: slotProps.index
                        }, () => [
                            _createElementVNode("div", _hoisted_4, " Items in group: " + _toDisplayString(calculateGroupCount(slotProps.data[__props.groupBy])), 1)
                        ])
                    ]),
                    default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.columns, (column, colIndex) => {
                            return (_openBlock(), _createBlock(_unref(TableColumn), {
                                key: colIndex,
                                field: column.property,
                                header: column.header,
                                sortable: column.sortable,
                                style: _normalizeStyle(getColumnStyle(column))
                            }, {
                                body: _withCtx(({ data }) => [
                                    _renderSlot(_ctx.$slots, column.property, {
                                        item: data,
                                        value: data[column.property],
                                        column: column
                                    }, () => [
                                        (column.type == 'decimals')
                                            ? (_openBlock(), _createBlock(_component_UDecimal, _mergeProps({
                                                key: 0,
                                                value: data[column.property]
                                            }, { ref_for: true }, column.decimalOptions), null, 16, ["value"]))
                                            : (column.type == 'menu' && column.menuFunction)
                                                ? (_openBlock(), _createBlock(TableDropdownMenu, {
                                                    key: 1,
                                                    items: column.menuFunction(data)
                                                }, null, 8, ["items"]))
                                                : (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(data[column.property]), 1))
                                    ])
                                ]),
                                _: 2
                            }, 1032, ["field", "header", "sortable", "style"]));
                        }), 128)),
                        _renderSlot(_ctx.$slots, "default")
                    ]),
                    _: 3
                }, 16, ["value", "group-rows-by", "row-group-mode", "sort-field"]),
                (isPaginationVisibility.value)
                    ? (_openBlock(), _createBlock(UPaginator, {
                        key: 0,
                        "total-records": totalRecords.value,
                        onPage: onPageChange
                    }, null, 8, ["total-records"]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
